module.exports = __webpack_public_path__ + "assets/img/bg_zstp.2fb43bb0.jpg";